// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"4f88cd80","220":"19db0162","372":"01cc4ccb","609":"1faebc6d","624":"2561c580","784":"6d0118ed","823":"6e7a1611"}[chunkId] + ".chunk.js";
};